import { useEffect, useRef } from "react";
import { startGoogleTranslation } from "@/lib/translation/googleTranslate";
import { useGoogleText } from "@/lib/translation/useGoogleText";

const DATE_FIELDS = [
  "Year",
  "Month",
  "Day",
  "Hours",
  "Minutes",
  "Seconds",
  "Weekday",
  "Week",
  "Meridiem",
];

export function GoogleTranslation() {
  const translate = useGoogleText(DATE_FIELDS);
  const fieldSources = useRef(new WeakMap<Element, string>());
  useEffect(startGoogleTranslation, []);
  useEffect(() => {
    function updateFields() {
      for (const field of document.querySelectorAll(
        '[contenteditable][role="spinbutton"]',
      )) {
        const current = field.getAttribute("aria-label") || "";
        if (DATE_FIELDS.includes(current))
          fieldSources.current.set(field, current);
        const source = fieldSources.current.get(field);
        if (source && current !== translate(source))
          field.setAttribute("aria-label", translate(source));
      }
    }
    updateFields();
    const observer = new MutationObserver(updateFields);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["aria-label"],
    });
    return () => observer.disconnect();
  }, [translate]);
  return null;
}
